/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventNum: NonNullable<unknown> }} Error_Nav_Event_Selected_ToastInputs */

const en_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.eventNum} selected.`)
};

const fr_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evenement ${i?.eventNum} selectionne.`)
};

const de_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignis ${i?.eventNum} ausgewählt.`)
};

const it_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.eventNum} selezionato.`)
};

const ru_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выбрано событие ${i?.eventNum}.`)
};

const es_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.eventNum} seleccionado.`)
};

const zh_cn2_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已选择事件${i?.eventNum}。`)
};

const ja_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント${i?.eventNum}が選択されました。`)
};

const hi_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.eventNum} का चयन किया गया।`)
};

const pt_pt2_error_nav_event_selected_toast = /** @type {(inputs: Error_Nav_Event_Selected_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento ${i?.eventNum} selecionado.`)
};

/**
* | output |
* | --- |
* | "Event {eventNum} selected." |
*
* @param {Error_Nav_Event_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_selected_toast = /** @type {((inputs: Error_Nav_Event_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_event_selected_toast(inputs)
	if (locale === "de") return de_error_nav_event_selected_toast(inputs)
	if (locale === "it") return it_error_nav_event_selected_toast(inputs)
	if (locale === "ru") return ru_error_nav_event_selected_toast(inputs)
	if (locale === "es") return es_error_nav_event_selected_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_event_selected_toast(inputs)
	if (locale === "ja") return ja_error_nav_event_selected_toast(inputs)
	if (locale === "hi") return hi_error_nav_event_selected_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_event_selected_toast(inputs)
	return en_error_nav_event_selected_toast(inputs)
});